const translations = {
  "en": {
    "%{price} a day": "%{price} a day",
    "%{price} a year. About what a nanny costs in a day.": "%{price} a year. About what a nanny costs in a day.",
    "%{price} one-time payment. No renewal.": "%{price} one-time payment. No renewal.",
    "%{price}/mo, renews monthly unless cancelled.": "%{price}/mo, renews monthly unless cancelled.",
    "%{price}/wk, renews weekly unless cancelled.": "%{price}/wk, renews weekly unless cancelled.",
    "%{price}/yr, renews yearly unless cancelled.": "%{price}/yr, renews yearly unless cancelled.",
    "%{trialPrice} for %{days} days, then %{price}/yr unless cancelled.": "%{trialPrice} for %{days} days, then %{price}/yr unless cancelled.",
    "%{trialPrice} for 1 day, then %{price}/yr unless cancelled.": "%{trialPrice} for 1 day, then %{price}/yr unless cancelled.",
    "Annual": "Annual",
    "By purchasing, you agree to our": "By purchasing, you agree to our",
    "Cancel anytime. By subscribing, you agree to our": "Cancel anytime. By subscribing, you agree to our",
    "Free for %{days} days, then %{price}/yr unless cancelled.": "Free for %{days} days, then %{price}/yr unless cancelled.",
    "Free for 1 day, then %{price}/yr unless cancelled.": "Free for 1 day, then %{price}/yr unless cancelled.",
    "Get Ed Complete": "Get Ed Complete",
    "Get Ed Lifetime · %{price}": "Get Ed Lifetime · %{price}",
    "Lifetime": "Lifetime",
    "Monthly": "Monthly",
    "One-time charge": "One-time charge",
    "One-time payment": "One-time payment",
    "Pays off in %{years} yr": "Pays off in %{years} yr",
    "Renews monthly": "Renews monthly",
    "Renews weekly": "Renews weekly",
    "Save %{discount}%": "Save %{discount}%",
    "Start my %{days}-day free trial": "Start my %{days}-day free trial",
    "Start my %{days}-day trial": "Start my %{days}-day trial",
    "Try it out": "Try it out",
    "Weekly": "Weekly"
  },
  "zh-tw": {
    "%{price} a day": "%{price}/天",
    "%{price} a year. About what a nanny costs in a day.": "%{price} 每年。大約是保母一天的費用。",
    "%{price} one-time payment. No renewal.": "%{price} 一次性付款。不續訂。",
    "%{price}/mo, renews monthly unless cancelled.": "%{price}/月，除非取消，否則每月自動續訂。",
    "%{price}/wk, renews weekly unless cancelled.": "%{price}/週，除非取消，否則每週自動續訂。",
    "%{price}/yr, renews yearly unless cancelled.": "%{price}/年，除非取消，否則每年自動續訂。",
    "%{trialPrice} for %{days} days, then %{price}/yr unless cancelled.": "%{trialPrice} 體驗 %{days} 天，之後為 %{price}/年，未取消將自動續訂。",
    "%{trialPrice} for 1 day, then %{price}/yr unless cancelled.": "%{trialPrice} 體驗 1 天，之後 %{price}/yr，未取消將持續計費。",
    "Annual": "年度",
    "By purchasing, you agree to our": "購買即表示您同意我們的",
    "Cancel anytime. By subscribing, you agree to our": "隨時取消。訂閱即表示您同意我們的",
    "Free for %{days} days, then %{price}/yr unless cancelled.": "免費試用 %{days} 天，之後為 %{price}/年，除非取消，否則自動續訂。",
    "Free for 1 day, then %{price}/yr unless cancelled.": "免費體驗 1 天，之後 %{price}/年，未取消將自動續訂。",
    "Get Ed Complete": "訂閱 Ed Complete",
    "Get Ed Lifetime · %{price}": "取得 Ed 終身方案 · %{price}",
    "Lifetime": "終身",
    "Monthly": "每月",
    "One-time charge": "一次性費用",
    "One-time payment": "一次性付款",
    "Pays off in %{years} yr": "預計 %{years} 年回本",
    "Renews monthly": "每月自動續訂",
    "Renews weekly": "每週自動續訂",
    "Save %{discount}%": "省 %{discount}%",
    "Start my %{days}-day free trial": "開始 %{days} 天免費試用",
    "Start my %{days}-day trial": "開始 %{days} 天試用",
    "Try it out": "試試看",
    "Weekly": "每週"
  }
};

export default translations;
